import { render, staticRenderFns } from "./MailsPage.vue?vue&type=template&id=18729d3c&"
import script from "./MailsPage.vue?vue&type=script&lang=js&"
export * from "./MailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports